import * as React from 'react';
import Box from '@lce/slice_v2/Layout/Box';

interface IDirection {
  direction: 'ltr' | 'rtl';
}

export const Direction: React.FC<IDirection> = ({ direction, ...props }) => (
  <Box sx={{ direction }} {...props} />);
